export default "__VITE_ASSET__o9TKHhGT__"